export const ABUSE_DOMAIN = 'www.ovhcloud.com'
